export default __webpack_public_path__ + "images/PY.7fef203.png";